import React from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowAltCircleLeft } from '@fortawesome/free-solid-svg-icons';
import { FormattedMessage } from 'react-intl';
import Sidebar from './Sidebar';
import { configs } from '@constants/configs/configs';
import { BREAK_POINTS } from '@constants/common/breakpoints';
import { cleanQueryParams } from '@utils/miscellaneous/urlSearchParams';

interface LayoutProps {
    children: React.ReactNode;
}

const StyledContainer = styled.div`
    max-width: 1280px;
    margin: auto;
    display: flex;
    margin-top: 20px;
    padding: 0px 20px;
    min-height: calc(100vh - 420px);
    @media (max-width: ${BREAK_POINTS.sm}) {
        display: block;
        margin-top: 0;
    }
`;

const StyledRightPanel = styled.div`
    width: 75%;
    margin-left: 25px;

    @media (max-width: ${BREAK_POINTS.sm}) {
        width: 100%;
        margin-left: 0;
        margin-top: 20px;
    }
`;

const StyledIconContainer = styled.div`
    display: flex;
    margin: auto;
    margin-bottom: 20px;
    margin-top: 20px;
    max-width: 1280px;
    align-items: center;
    color: ${({ theme }) => theme.primaryMain};
    padding: 0px 20px;

    &:hover {
        color: ${({ theme }) => theme.primaryDark};
    }
    @media (max-width: ${BREAK_POINTS.sm}) {
        width: 100%;
    }
`;

const StyledIconLabel = styled.div`
    margin-left: 6px;
    margin-top: 2px;
    cursor: pointer;
    font-size: ${({ theme }) => theme.fontSizeBody};
    font-weight: 600;
`;

export const StyledIdentityHeader = styled.h1<{ fontWeight?: number }>`

`;

const StyledButton = styled.button`
    display: inline-flex;
    align-items: center;
    background-color: ${({ theme }) => theme.gray11};
    color: ${({ theme }) => theme.primaryDark};
    border: none;
    cursor: pointer;
`;

const Layout: React.FC<LayoutProps> = ({ children }) => {
    const {
        routes: { SSAP },
    } = configs;

    const backToApplication = () => {
        const queryParams = new URLSearchParams(window.location.search);
        const existingParams = cleanQueryParams(queryParams);
        const coverageYear = existingParams['coverageYear'];
        const applicationType = existingParams['applicationType'];
        const caseNumber = existingParams['caseNumber'];
        if (caseNumber) {
            window.location.href = `${SSAP}?caseNumber=${caseNumber}`;
        } else if (coverageYear && applicationType) {
            window.location.href = `${SSAP}?applicationType=${applicationType}&coverageYear=${coverageYear}`;
        } else {
            window.location.href = `${SSAP}`;
        }
    };
    return (
        <>
            <StyledIconContainer>
                <StyledButton onClick={backToApplication}>
                    <FontAwesomeIcon icon={faArrowAltCircleLeft} />
                    <StyledIconLabel>
                        <FormattedMessage id="ridp.backToApplication" />
                    </StyledIconLabel>
                </StyledButton>
            </StyledIconContainer>
            <StyledContainer>
                <Sidebar />
                <StyledRightPanel>{children}</StyledRightPanel>
            </StyledContainer>
        </>
    );
};

export default Layout;
